var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 46,
    viewBox: "0 0 200 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1464_7727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.879 1.87868C162 2.75736 162 4.17157 162 6.99999V25.9038C162 27.2586 162 27.936 162.273 28.5317C162.547 29.1274 163.06 29.5692 164.087 30.4526L177.087 41.6346C178.954 43.2401 179.887 44.0429 181 44.0429C182.113 44.0429 183.046 43.2401 184.913 41.6346L197.913 30.4526C198.94 29.5692 199.453 29.1274 199.727 28.5317C200 27.936 200 27.2586 200 25.9038V7C200 4.17157 200 2.75736 199.121 1.87868C198.243 1 196.828 1 194 1H168C165.172 1 163.757 1 162.879 1.87868ZM189.957 19.9465L181 11.0571L172.043 19.9465L181 28.8358L189.957 19.9465Z",
    fill: "#292D32"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 28.6571L184.913 41.6346C183.046 43.2401 182.113 44.0429 181 44.0429C179.887 44.0429 178.954 43.2401 177.087 41.6346L177.087 41.6346L162.05 28.7005L162 28.7451V28.6571L162.05 28.7005L172.045 19.8571L181 28.8331L189.955 19.8571L200 9.888V28.6571Z",
    fill: "#00A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.156 19.2414L134.237 14.6434C135.552 13.1616 137.842 13.09 139.247 14.4869L148.073 23.2616C150.255 25.431 148.718 29.1552 145.641 29.1552H124.017C117.352 29.1552 111.948 23.7517 111.948 17.0862V4.5862",
    stroke: "#292D32",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.427 43.3793V39.931H144.895V43.3793H141.427Z",
    stroke: "#00A6A6",
    strokeWidth: 3.44828
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2651 10.6207V7.17241H89.4039V10.6207H77.2651Z",
    stroke: "#00A6A6",
    strokeWidth: 3.44828
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0527 43.3793V39.931H58.1914V43.3793H46.0527Z",
    stroke: "#00A6A6",
    strokeWidth: 3.44828
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3756 15.7931V17.5172C99.3756 24.1827 93.9722 29.5862 87.3066 29.5862H35.2138M35.2138 29.5862V5.01724M35.2138 29.5862H16.069C9.40347 29.5862 4 24.1827 4 17.5172V16.6552",
    stroke: "#292D32",
    strokeWidth: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1922 2L14.8939 4.43408C14.3016 5.06135 13.9717 5.89139 13.9717 6.7541V6.7541C13.9717 8.62045 15.4847 10.1334 17.351 10.1334H19.6694M19.6694 10.1334L22.6422 6.98501M19.6694 10.1334L15.9535 14.069",
    stroke: "#292D32",
    strokeWidth: 4.31035
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1464_7727",
    x: 162,
    y: -1,
    width: 38,
    height: 45.0429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1464_7727"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.b8c0aef019339d31c0ae01b581d9ba21.svg";
export { ForwardRef as ReactComponent };